import React from 'react';

export interface RecordTitleProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  eyebrow?: React.ReactNode;
  className?: string;
}

const RecordTitle: React.FC<RecordTitleProps> = ({
  title,
  subtitle,
  eyebrow,
  className = '',
}) => (
  <div className={`min-w-0 ${className}`}>
    {eyebrow && (
      <div className="mb-1 text-[11px] font-bold uppercase tracking-[0.14em] text-monday-text-muted">
        {eyebrow}
      </div>
    )}
    <div className="truncate text-sm font-bold leading-5 tracking-tight text-monday-text">
      {title}
    </div>
    {subtitle && (
      <div className="mt-0.5 truncate text-xs leading-4 text-monday-text-muted">
        {subtitle}
      </div>
    )}
  </div>
);

export default RecordTitle;
